import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    Input,
    OnInit,
    signal,
    ViewChild,
} from '@angular/core';
import { IChecklistGroup, ILink, ISocialMediaItem, MediaImage, SpacerComponent, ChecklistComponent, GridComponent, HeadingComponent, CheckmarkComponent } from '@sirius/common';
import { HighlightedItemWithLink } from 'shared/models';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { InfoOverviewComponent } from 'shared';
import { ContentExpansionContainerComponent } from '../content-expansion-container/content-expansion-container.component';

@Component({
    selector: 'commerce-partner-page-info-section',
    templateUrl: './partner-page-info-section.component.html',
    styleUrl: './partner-page-info-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InfoOverviewComponent, SpacerComponent, ContentExpansionContainerComponent, ChecklistComponent, GridComponent, HeadingComponent, CheckmarkComponent, TranslatePipe]
})
export class PartnerPageInfoSectionComponent implements OnInit {
    translateService = inject(TranslateService);
    router = inject(Router);

    @Input() partnerTitle = '';
    @Input() partnerName = '';
    @Input() partnerDescription = '';
    @Input() logo?: MediaImage | null = null;
    @Input() highlightItems: HighlightedItemWithLink[] = [];
    @Input() socialMediaLinks: ISocialMediaItem[] = [];
    @Input() checklistGroups: IChecklistGroup[] = [];
    @Input() availability: string[] = [];
    @Input() highlightTitle? = '';

    @ViewChild('partnerPageBrandInfo', { read: ElementRef }) partnerPageBrandInfo?: ElementRef =
        undefined;

    availabilityColumns: string[][] = [];
    expandableContent = false;
    formLink = signal<ILink | null>(null);

    async ngOnInit() {
        if (this.checklistGroups != undefined && this.checklistGroups[0]?.items.length > 0) {
            this.expandableContent = true;
        }

        if (this.availability.length > 0) {
            this.availabilityColumns = this.splitAvailabilityIntoColumns();
        }

        this.setFormLink();
    }

    scrollOnCollapse() {
        this.partnerPageBrandInfo?.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
        });
    }

    splitAvailabilityIntoColumns(): string[][] {
        if (this.availability.length < 10) {
            return [this.availability];
        }

        const columns: string[][] = [];
        const columnCount = 2;
        const itemsPerColumn = Math.ceil(this.availability.length / columnCount);

        for (let i = 0; i < columnCount; i++) {
            const startIndex = i * itemsPerColumn;
            const endIndex = startIndex + itemsPerColumn;
            columns.push(this.availability.slice(startIndex, endIndex));
        }

        return columns;
    }

    setFormLink() {
        const currentUrl = this.router.url;
        const cleanUrl = currentUrl.split('#')[0];

        this.translateService.get('commerce.contactUs').subscribe((translatedTitle) => {
            this.formLink.set({
                title: translatedTitle,
                href: cleanUrl,
                anchor: 'anchor-form',
            });
        });
    }
}
